module.exports = __webpack_public_path__ + "static/1_1_defineai_LV-7bd9c94645760f43d7d5c9f623e5e415.svg";